export default __webpack_public_path__ + "static/media/money_1.e39d52ea.png";